let privateKey: CryptoKey | null = null;
const workspaceKeys = new Map<string, CryptoKey>();
const listeners = new Set<() => void>();

export function passwordSessionSnapshot(): boolean {
  return privateKey !== null;
}

export function subscribePasswordSession(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function unlockPasswordSession(key: CryptoKey): void {
  privateKey = key;
  emit();
}

export function lockPasswordSession(): void {
  privateKey = null;
  workspaceKeys.clear();
  emit();
}

export function passwordPrivateKey(): CryptoKey {
  if (!privateKey) throw new Error("Der PasswortStore ist gesperrt.");
  return privateKey;
}

export function cacheWorkspaceKey(workspaceId: string, key: CryptoKey): void {
  workspaceKeys.set(workspaceId, key);
}

export function cachedWorkspaceKey(workspaceId: string): CryptoKey | null {
  return workspaceKeys.get(workspaceId) ?? null;
}

function emit(): void {
  for (const listener of listeners) listener();
}
